import { KeyValue } from '@/main/models/common';
import { CompanyAnnouncerFilterRequest } from '@/main/models/request/announcementRequest';

export enum AnnouncementTypes {
  GET_DOMAIN_ANNOUNCEMENTS = '@announcement/GET_DOMAIN_ANNOUNCEMENTS',
  SAVE_DOMAIN_ANNOUNCEMENTS = '@announcement/SAVE_DOMAIN_ANNOUNCEMENTS',
  GET_STATUS_DOMAIN = '@announcement/GET_STATUS_DOMAIN',
  SAVE_STATUS_DOMAIN = '@announcement/SAVE_STATUS_DOMAIN',
  GET_DOMAIN_COMPANY_ANNOUNCERS = '@announcement/GET_DOMAIN_COMPANY_ANNOUNCERS',
  SAVE_DOMAIN_COMPANY_ANNOUNCERS = '@announcement/SAVE_DOMAIN_COMPANY_ANNOUNCERS',
  GET_DOMAIN_WHO_CAN_SEE = '@announcement/GET_DOMAIN_WHO_CAN_SEE',
  SAVE_DOMAIN_WHO_CAN_SEE = '@announcement/SAVE_DOMAIN_WHO_CAN_SEE'
}

export interface AnnouncementState {
  readonly domain: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };

  readonly statusDomain: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };

  readonly domainCompanyAnnouncers: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };

  readonly domainWhoCanSee: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetDomainAnnouncements {
  type: typeof AnnouncementTypes.GET_DOMAIN_ANNOUNCEMENTS;
  payload: {
    guidCompany?: string;
  };
}

export interface SaveDomainAnnouncements {
  type: typeof AnnouncementTypes.SAVE_DOMAIN_ANNOUNCEMENTS;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface GetStatusDomain {
  type: typeof AnnouncementTypes.GET_STATUS_DOMAIN;
  payload: { showExpired?: boolean };
}

export interface SaveStatusDomain {
  type: typeof AnnouncementTypes.SAVE_STATUS_DOMAIN;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface GetDomainCompanyAnnouncers {
  type: typeof AnnouncementTypes.GET_DOMAIN_COMPANY_ANNOUNCERS;
  payload: { request: CompanyAnnouncerFilterRequest };
}

export interface SaveDomainCompanyAnnouncers {
  type: typeof AnnouncementTypes.SAVE_DOMAIN_COMPANY_ANNOUNCERS;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface GetDomainWhoCanSee {
  type: typeof AnnouncementTypes.GET_DOMAIN_WHO_CAN_SEE;
}

export interface SaveDomainWhoCanSee {
  type: typeof AnnouncementTypes.SAVE_DOMAIN_WHO_CAN_SEE;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export type AnnouncementActionTypes =
  | GetDomainAnnouncements
  | SaveDomainAnnouncements
  | GetStatusDomain
  | SaveStatusDomain
  | GetDomainCompanyAnnouncers
  | SaveDomainCompanyAnnouncers
  | GetDomainWhoCanSee
  | SaveDomainWhoCanSee;
